export default __webpack_public_path__ + "static/media/keep_going.732696ec.svg";